interface Props {
  fullName: string;
  avatarUrl?: string | null;
  size?: number;
}

function initials(name: string): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function InboxAvatar({ fullName, avatarUrl, size = 24 }: Props) {
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={fullName}
        title={fullName}
        className="rounded-full object-cover shrink-0 border border-border"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      title={fullName}
      className="inline-flex items-center justify-center rounded-full bg-muted text-foreground/80 text-[10px] font-semibold border border-border shrink-0"
      style={{ width: size, height: size }}
    >
      {initials(fullName)}
    </span>
  );
}
